import { collection, doc, getDocs, addDoc, updateDoc, deleteDoc, serverTimestamp, query, orderBy } from 'firebase/firestore';
import { db } from './firebase';
import type { RegisteredMember, MemberFormData, FamilyMember } from '../types/member';

const membersCollectionRef = collection(db, 'members');

export const memberService = {
  async getAllRegisteredMembers(): Promise<RegisteredMember[]> {
    const q = query(membersCollectionRef, orderBy('createdAt', 'desc'));
    const data = await getDocs(q);
    return data.docs.map(doc => {
      const docData = doc.data();
      return {
        ...docData,
        id: docData.id || doc.id, // Cloud Function으로 생성된 id를 우선 사용, 없으면 doc.id 사용
      } as RegisteredMember;
    });
  },
  async addRegisteredMember(memberData: MemberFormData): Promise<string> {
    const docRef = await addDoc(membersCollectionRef, { ...memberData, createdAt: serverTimestamp(), updatedAt: serverTimestamp() });
    return docRef.id;
  },
  async updateRegisteredMember(id: string, updates: Partial<MemberFormData>): Promise<void> {
    const memberDoc = doc(db, 'members', id);
    await updateDoc(memberDoc, { ...updates, updatedAt: serverTimestamp() });
  },
  async deleteRegisteredMember(id: string): Promise<void> {
    const memberDoc = doc(db, 'members', id);
    await deleteDoc(memberDoc);
  },

  // --- Family Members Subcollection ---

  async getFamilyMembers(memberId: string): Promise<FamilyMember[]> {
    const familyCollectionRef = collection(db, 'members', memberId, 'family');
    const q = query(familyCollectionRef, orderBy('relationship'));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as FamilyMember));
  },

  async addFamilyMember(memberId: string, familyMemberData: Omit<FamilyMember, 'id'>): Promise<string> {
    const familyCollectionRef = collection(db, 'members', memberId, 'family');
    const docRef = await addDoc(familyCollectionRef, familyMemberData);
    return docRef.id;
  },

  async removeFamilyMember(memberId: string, familyMemberId: string): Promise<void> {
    const familyMemberDocRef = doc(db, 'members', memberId, 'family', familyMemberId);
    await deleteDoc(familyMemberDocRef);
  },
};
